export default __webpack_public_path__ + "static/media/applications1.49fc18f0.png";